var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{class:_vm.xs ? 'ma-4': null,attrs:{"type":"error","border":"left"}},[_vm._v(" "+_vm._s(_vm.url)+" 은 없는 경로 입니다. ")])}
var staticRenderFns = []

export { render, staticRenderFns }